import { getCountry, getManualByCountry } from '../utils';

const country = getCountry();
const withCom = getWithDotComByCountry(country);
const docHost = `http://help-dv.neogig${withCom}${country}`;
const linkManual = getManualByCountry(country, docHost);

export const env = {
  NODE_ENV: 'development',
  NEOGIG_CLIENT_ID: 'neogig_dev',
  NEODASH_CLIENT_ID_NEODASH: 'neodash_dev',
  MAPBOX_KEY: `pk.eyJ1IjoibmVvY29tc2VydmljZSIsImEiOiJjbWRodGl3ZjkwNWd5MmpxMXMzM2RubWlxIn0.cVfKHNfwS3HgtJn4rj1vPg`,
  CARTO_KEY: 'cb1_28bg_1_0356ced9998003b244e01e82',
  URL: {
    NEOGIG_HOST: `http://dv.neogig${withCom}${country}`,
    NEODASH_HOST: `http://neodash-dv.neogig${withCom}${country}/neodash`,
    API_HOST: `http://neogig-api-dv.neogig${withCom}${country}/api/v1`,
    MANUAL_URL: linkManual,
    IDENTITY_SERVER_URL: `http://identity-server-dv.neogig${withCom}${country}`,
    CTRL_PANEL_API: `http://cp-dv.neogig${withCom}${country}`,
  }
};



// WEBPACK FOOTER //
// ./src/config/dev.env.js